
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./assets/js/forage_foundation.js";
              export default OriginalModule.default;
              export * from "./assets/js/forage_foundation.js";